<template>
    <div class="vue-where-am-i">
        <a @click.prevent="show" href="#" class="where-am-i"><i class="icon-locatie-pin-solid"></i></a>

        <modal :id="modalId" :name="modalId" width="90%" :maxWidth="950" :adaptive="true" height="auto" :scrollable="true" @before-close="handleClose">
            <div class="modal-inner-wrapper">
                <a class="close-button" href="" @click.prevent="close"><i class="icon-close-thin"></i></a>
                <h3>{{ modalTitle }}</h3>

                <div class="modal-slot-wrapper" style="height: 400px;">
                    <GmapMap
                        :center="position"
                        :zoom="14"
                        style="height: 400px"
                    >
                        <GmapMarker
                          :position="position"
                          @click="center = position"></GmapMarker>
                    </GmapMap>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import modalMixin from "../mixins/modalMixin";

export default {
    name: "WhereAmI",

    props: ['modalTitle', 'geolat', 'geolng'],

    mixins: [modalMixin],

    computed: {
        position() {
            return {
               lat: parseFloat( this.geolat ),
               lng: parseFloat( this.geolng )
            }
        },

        modalId() {
            return _.uniqueId('modal-where-am-i-');
        }
    }
}
</script>
